import { OTR_STATUS } from './otrEnums';

export const OTR_STATUS_CONFIG = {
  [OTR_STATUS.DRAFT]: {
    label: 'Draft',
    bg: 'var(--status-warning-bg)',
    fg: 'var(--status-warning-fg)',
    dot: 'var(--status-warning-dot)',
  },
  [OTR_STATUS.SUBMITTED]: {
    label: 'Travel Request Submitted',
    bg: 'var(--status-submitted-bg)',
    fg: 'var(--status-submitted-fg)',
    dot: 'var(--status-submitted-dot)',
  },
  [OTR_STATUS.L1_APPROVED]: {
    label: 'L1 Approved',
    bg: 'var(--status-submitted-bg)',
    fg: 'var(--status-submitted-fg)',
    dot: 'var(--status-submitted-dot)',
  },
  [OTR_STATUS.APPROVED]: {
    label: 'Travel Approved',
    bg: 'var(--status-published-bg)',
    fg: 'var(--status-published-fg)',
    dot: 'var(--status-published-dot)',
  },
  [OTR_STATUS.SENT_BACK]: {
    label: 'Sent Back',
    bg: 'var(--status-warning-bg)',
    fg: 'var(--status-warning-fg)',
    dot: 'var(--status-warning-dot)',
  },
  [OTR_STATUS.REJECTED]: {
    label: 'Rejected',
    bg: 'var(--status-rejected-bg)',
    fg: 'var(--status-rejected-fg)',
    dot: 'var(--status-rejected-dot)',
  },
  [OTR_STATUS.CANCELLED]: {
    label: 'Cancelled',
    bg: 'var(--status-archived-bg)',
    fg: 'var(--status-archived-fg)',
    dot: 'var(--status-archived-dot)',
  },
  [OTR_STATUS.EXPENSES_SUBMITTED]: {
    label: 'Expenses Submitted',
    bg: 'var(--status-submitted-bg)',
    fg: 'var(--status-submitted-fg)',
    dot: 'var(--status-submitted-dot)',
  },
  [OTR_STATUS.EXPENSES_L1_APPROVED]: {
    label: 'Expenses L1 Approved',
    bg: 'var(--status-submitted-bg)',
    fg: 'var(--status-submitted-fg)',
    dot: 'var(--status-submitted-dot)',
  },
  [OTR_STATUS.EXPENSES_APPROVED]: {
    label: 'Expenses Approved',
    bg: 'var(--status-published-bg)',
    fg: 'var(--status-published-fg)',
    dot: 'var(--status-published-dot)',
  },
};
